import { Component, Inject, Input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpecialModule } from 'lib/modules/special.module';
import { ButtonComponent } from '../../../../../components/button/button.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CategoryService } from 'lib/services/category/category.service';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';

@Component({
    selector: 'cms-partial-category-top-component-colored-block',
    templateUrl: './colored-block.component.html',
    styleUrls: ['./colored-block.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, SpecialModule, ButtonComponent],
})
export class ColoredBlockComponent extends CmsPartialComponentClass {
    @Input() coloredBlockRow: any;
    @Input() dataUrl: string = '';
    @Input() dataTitle: string = '';
    @Input() solutionID: string = '';
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;
    readonly backgroundDesignUrl: string = 'https://assets.exxactcorp.com/img/exx/cms/ad-blocks/color-block-img-remake.svg';

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        public bootstrapMarketoService: BootstrapMarketoService,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                breakpointObserver,
                bootstrapMarketoService,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src) ?? '';
    }

    getLinkUrl(url: string): string {
        return this.getCategoryPageLink(url);
    }
}
